import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

const CancelToken = axiosInstance.CancelToken;

let getShipmentInfoServiceCancelToken = () => {};
let saveShipmentOtherDetailsCancelToken = () => {};

export const getShipmentInfoService = (data) => {
  getShipmentInfoServiceCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getShipmentInfoServiceCancelToken = c;
    }),
    data,
    method: 'post',
    url: `${API.POV}/GetShipmentInformation`,
  });
};

export const saveShipmentOtherDetailsService = (data) => {
  saveShipmentOtherDetailsCancelToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      saveShipmentOtherDetailsCancelToken = c;
    }),
    data,
    method: 'post',
    url: `${API.POV}/UpdateShipmentDetails`,
  });
};
